import { Routes } from "@/shared/constants/Routing";
import type { IndustryPreset } from "@/shared/types/industryPreset";

const PATH_TO_INDUSTRY_PRESET: Partial<Record<string, IndustryPreset>> = {
    /** Главная: CTA «Попробовать бесплатно» — предустановленная розница */
    [Routes.HOME]: "RETAIL",
    [Routes.TELEGRAM_HORECA]: "HORECA",
    [Routes.TELEGRAM_BEAUTY]: "BEAUTY",
    [Routes.TELEGRAM_SHOP]: "RETAIL",
    [Routes.TELEGRAM_SERVICES]: "SERVICES",
    [Routes.TELEGRAM_EVENTS]: "SERVICES",
    [Routes.TELEGRAM_SERVICE_COMPANIES]: "SERVICES",
};

function normalizePathname(pathname: string): string {
    if (!pathname) return "/";
    if (pathname.length > 1 && pathname.endsWith("/")) {
        return pathname.slice(0, -1);
    }
    return pathname;
}

export function getIndustryPresetByPathname(pathname: string): IndustryPreset | undefined {
    return PATH_TO_INDUSTRY_PRESET[normalizePathname(pathname)];
}
